import { Navigate, useParams } from 'react-router-dom';

import { toLessonTabHref } from '@/utils/lesson/lessonTabs';

import { useLessonOutletContext } from './lessonOutletContext';

export default function LessonTabIndexRedirect() {
  const { tabs } = useLessonOutletContext();
  const { slugCourseName = '', lessonId = '', klassId } = useParams();

  const firstTabHref = tabs
    .map(({ type }) =>
      toLessonTabHref({ slug: slugCourseName, lessonId, klassId }, type),
    )
    .find(Boolean);

  if (!firstTabHref) return null;

  return <Navigate to={firstTabHref} replace />;
}
